const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
  topText: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '19px',
    marginBottom: '6px',
  },
  maxText: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginLeft: '4px',
  },
  addOptionText: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginLeft: '4px',
    '&:hover': {
      cursor: 'pointer',
      color: 'var(--color-text-primary)',
    },
  },
  gridRow: {
    width: '100%',
  },
  columnNameInput: {
    width: '100%',
    minWidth: '200px',
    marginBottom: '8px',
    height: '200px',
  },
  optionInput: {
    width: '100%',
    display: 'inline-block',
  },
  selectList: {
    width: '100%',
    marginBottom: '8px',
    background: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    borderRadius: '2px',
    padding: '2px',
  },
  columnGridContainer: {
    paddingBottom: '24px',
    maxWidth: '200px',
  },
  inputWithIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  exportTypeSelect: {
    marginBottom: '24px',
    background: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    minWidth: '300px',
    borderRadius: '2px',
    padding: '8px 12px',
  },
  numRowsInput: {
    minWidth: '300px',
    marginBottom: '32px',
  },
  addIcon: {
    height: '18px',
    width: '18px',
    color: theme.palette.text.secondary,
    '&:hover': {
      cursor: 'pointer',
      color: 'var(--color-text-primary)',
    },
  },
  removeIcon: {
    height: '18px',
    width: '18px',
    color: theme.palette.text.secondary,
    '&:hover': {
      cursor: 'pointer',
      color: 'var(--color-text-primary)',
    },
  },
  textIcon: {
    width: '18px',
    height: '18px',
    marginRight: '4px',
  },
  errorSection: {
    display: 'flex',
    alignItems: 'center',
    color: '#b00020',
    fontSize: '14px',
  },
  optionGridItem: {
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  topTitleContainer: { marginBottom: '24px' },
  tableSettingsTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  requiredText: {
    color: theme.palette.text.secondary,
    fontSize: '14px',
    lineHeight: '19px',
  },
  requiredCheckbox: {
    padding: '0px',
    marginRight: '4px',
  },
  requiredGridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '4px 0px',
  },
  dropdownIcon: {
    height: '18px',
    width: '18px',
    marginLeft: '-2px',
    marginRight: '4px',
  },
});
export default styles;
